// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `html, body {
  margin: 0;
  padding: 0;
}

.main-container {
  overflow-x: hidden;
}

.home {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 0;
  min-height: 100vh;
}
.home .jedi_hr_logo {
  width: 300px;
}
.home h3 {
  font-weight: 500;
}

.homePage {
  font-family: "Century Gothic", sans-serif;
  color: #012748;
  background-color: #fede8c;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 20px;
  min-height: 100vh;
}
.homePage .header {
  width: 100%;
  text-align: center;
}
.homePage .header .top-bar {
  background-color: #012748;
  padding: 20px 0;
}
.homePage .header .top-bar .jedi_hr_logo {
  max-width: 150px;
  height: auto;
  transition: all 0.3s ease;
}
.homePage .header .top-bar .jedi_hr_logo:hover {
  transform: scale(1.05);
}
.homePage .header .nav-bar {
  background-color: #0f4e6f;
  padding: 10px 0;
  margin-bottom: 20px;
}
.homePage .header .nav-bar ul {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  justify-content: center;
  align-items: center;
}
.homePage .header .nav-bar ul li {
  margin: 0 15px;
}
.homePage .header .nav-bar ul li a {
  color: #fede8c;
  text-decoration: none;
  font-weight: bold;
  font-size: 1.1em;
}
.homePage .header .nav-bar ul li a:hover {
  color: #fe9816;
}
.homePage .content {
  width: 100%;
  max-width: 1200px;
  padding: 20px;
  text-align: center;
}
.homePage .content .partners {
  margin-bottom: 50px;
}
.homePage .content .partners h2 {
  font-size: 2.5em;
  color: #012748;
  margin-bottom: 30px;
  font-weight: bold;
}
.homePage .content .partners .partners-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
  gap: 20px;
  padding: 20px;
}
.homePage .content .partners .partners-grid .partner-card {
  background-color: #ffffff;
  border: 2px solid #012748;
  border-radius: 8px;
  padding: 15px;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}
.homePage .content .partners .partners-grid .partner-card:hover {
  transform: scale(1.05);
  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.15);
}
.homePage .content .partners .partners-grid .partner-card img {
  max-width: 100%;
  height: auto;
  margin-bottom: 10px;
  object-fit: contain;
}
.homePage .content .partners .partners-grid .partner-card h3 {
  color: #012748;
  font-size: 1.3em;
  margin-bottom: 10px;
}
.homePage .content .partners .partners-grid .partner-card p {
  font-size: 1em;
  color: #0f4e6f;
}
.homePage .content .description {
  max-width: 800px;
  margin: 0 auto;
  margin-bottom: 50px;
}
.homePage .content .description p {
  font-size: 1.2em;
  line-height: 1.8;
  color: #012748;
  text-align: justify;
  margin-bottom: 20px;
}

.footer {
  background-color: #012748;
  color: #fe9816;
  padding: 20px;
  text-align: center;
  width: 100%;
  position: relative;
}
.footer p {
  font-size: 1em;
  margin: 0;
}`, "",{"version":3,"sources":["webpack://./src/components/styles/home.scss","webpack://./src/components/styles/variables.scss"],"names":[],"mappings":"AAEC;EACI,SAAA;EACA,UAAA;AADL;;AAGC;EACG,kBAAA;AAAJ;;AAGA;ECTI,aAAA;EACA,sBDSc;ECRd,uBDQsB;ECPtB,mBDO8B;ECN9B,MDMsC;EACtC,iBAAA;AAIJ;AAHI;EACI,YAAA;AAKR;AAFI;EACI,gBAAA;AAIR;;AAAA;EACI,yCAAA;EACA,cAAA;EACA,yBAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,aAAA;EACA,iBAAA;AAGJ;AADI;EACI,WAAA;EACA,kBAAA;AAGR;AADQ;EACI,yBAAA;EACA,eAAA;AAGZ;AADY;EACI,gBAAA;EACA,YAAA;EACA,yBAAA;AAGhB;AADgB;EACI,sBAAA;AAGpB;AAEQ;EACI,yBAAA;EACA,eAAA;EACA,mBAAA;AAAZ;AAEY;EACI,gBAAA;EACA,UAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AAAhB;AAEgB;EACI,cAAA;AAApB;AAEoB;EACI,cAAA;EACA,qBAAA;EACA,iBAAA;EACA,gBAAA;AAAxB;AAEwB;EACI,cAAA;AAA5B;AAQI;EACI,WAAA;EACA,iBAAA;EACA,aAAA;EACA,kBAAA;AANR;AAQQ;EACI,mBAAA;AANZ;AAQY;EACI,gBAAA;EACA,cAAA;EACA,mBAAA;EACA,iBAAA;AANhB;AASY;EACI,aAAA;EACA,2DAAA;EACA,SAAA;EACA,aAAA;AAPhB;AASgB;EACI,yBAAA;EACA,yBAAA;EACA,kBAAA;EACA,aAAA;EACA,qDAAA;EACA,wCAAA;AAPpB;AASoB;EACI,sBAAA;EACA,0CAAA;AAPxB;AAUoB;EACI,eAAA;EACA,YAAA;EACA,mBAAA;EACA,mBAAA;AARxB;AAWoB;EACI,cAAA;EACA,gBAAA;EACA,mBAAA;AATxB;AAYoB;EACI,cAAA;EACA,cAAA;AAVxB;AAgBQ;EACI,gBAAA;EACA,cAAA;EACA,mBAAA;AAdZ;AAgBY;EACI,gBAAA;EACA,gBAAA;EACA,cAAA;EACA,mBAAA;EACA,mBAAA;AAdhB;;AAoBA;EACI,yBAAA;EACA,cAAA;EACA,aAAA;EACA,kBAAA;EACA,WAAA;EACA,kBAAA;AAjBJ;AAmBI;EACI,cAAA;EACA,SAAA;AAjBR","sourcesContent":["@import \"./variables.scss\";\n\n html, body {\n     margin: 0;\n     padding: 0;\n }\n .main-container {\n    overflow-x: hidden;\n}\n\n.home {\n    @include flex(column, center, center, 0);\n    min-height: 100vh;\n    .jedi_hr_logo {\n        width: 300px;\n    }\n\n    h3 {\n        font-weight: 500;\n    }\n}\n\n.homePage {\n    font-family: 'Century Gothic', sans-serif;\n    color: #012748;\n    background-color: #fede8c;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    padding: 20px;\n    min-height: 100vh;\n\n    .header {\n        width: 100%;\n        text-align: center;\n\n        .top-bar {\n            background-color: #012748;\n            padding: 20px 0;\n\n            .jedi_hr_logo {\n                max-width: 150px;\n                height: auto;\n                transition: all 0.3s ease;\n\n                &:hover {\n                    transform: scale(1.05);\n                }\n            }\n        }\n\n        .nav-bar {\n            background-color: #0f4e6f;\n            padding: 10px 0;\n            margin-bottom: 20px;\n\n            ul {\n                list-style: none;\n                padding: 0;\n                margin: 0;\n                display: flex;\n                justify-content: center;\n                align-items: center;\n\n                li {\n                    margin: 0 15px;\n\n                    a {\n                        color: #fede8c;\n                        text-decoration: none;\n                        font-weight: bold;\n                        font-size: 1.1em;\n\n                        &:hover {\n                            color: #fe9816;\n                        }\n                    }\n                }\n            }\n        }\n    }\n\n    .content {\n        width: 100%;\n        max-width: 1200px;\n        padding: 20px;\n        text-align: center;\n\n        .partners {\n            margin-bottom: 50px;\n\n            h2 {\n                font-size: 2.5em;\n                color: #012748;\n                margin-bottom: 30px;\n                font-weight: bold;\n            }\n\n            .partners-grid {\n                display: grid;\n                grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));\n                gap: 20px;\n                padding: 20px;\n\n                .partner-card {\n                    background-color: #ffffff;\n                    border: 2px solid #012748;\n                    border-radius: 8px;\n                    padding: 15px;\n                    transition: transform 0.3s ease, box-shadow 0.3s ease;\n                    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n\n                    &:hover {\n                        transform: scale(1.05);\n                        box-shadow: 0 6px 12px rgba(0, 0, 0, 0.15);\n                    }\n\n                    img {\n                        max-width: 100%;\n                        height: auto;\n                        margin-bottom: 10px;\n                        object-fit: contain;\n                    }\n\n                    h3 {\n                        color: #012748;\n                        font-size: 1.3em;\n                        margin-bottom: 10px;\n                    }\n\n                    p {\n                        font-size: 1em;\n                        color: #0f4e6f;\n                    }\n                }\n            }\n        }\n\n        .description {\n            max-width: 800px;\n            margin: 0 auto;\n            margin-bottom: 50px;\n\n            p {\n                font-size: 1.2em;\n                line-height: 1.8;\n                color: #012748;\n                text-align: justify;\n                margin-bottom: 20px;\n            }\n        }\n    }\n}\n\n.footer {\n    background-color: #012748;\n    color: #fe9816;\n    padding: 20px;\n    text-align: center;\n    width: 100%;\n    position: relative;\n\n    p {\n        font-size: 1em;\n        margin: 0;\n    }\n}","@mixin flex($d, $j, $a, $g) {\n    display: flex;\n    flex-direction: $d;\n    justify-content: $j;\n    align-items: $a;\n    gap: $g;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
